import { SharedTypes } from '@semios/app-platform-banyan-route-definitions'

export const flatNodeDevices = (
  nodeDevices?: SharedTypes.ServiceCenter.TNodeDevices,
): SharedTypes.ServiceCenter.TNodeDevice[] => {
  if (!nodeDevices) return []

  const devices: SharedTypes.ServiceCenter.TNodeDevice[] = []

  Object.keys(nodeDevices).forEach((connector) => {
    Object.keys(nodeDevices[connector as keyof SharedTypes.ServiceCenter.TNodeDevices]!).forEach(
      (channel) => {
        const device = nodeDevices[connector as keyof SharedTypes.ServiceCenter.TNodeDevices]![+channel]

        devices.push({
          ...device,
          connector: connector as keyof SharedTypes.ServiceCenter.TNodeDevices,
          channel: +channel,
        })
      },
    )
  })

  return devices
}

export const getPlannedDevices = (
  nodeDevices?: SharedTypes.ServiceCenter.TNodeDevices,
): SharedTypes.ServiceCenter.TNodeDevice[] => {
  if (!nodeDevices) return []

  const devicesArray = flatNodeDevices(nodeDevices)

  return devicesArray.filter(
    (device) => device.installationStatus === SharedTypes.ServiceCenter.NodeDeviceInstallationStatus.PLANNED,
  )
}
